import React from 'react';

const Learn = () => {
  return <div className="page-container ">Coming soon</div>;
};

export default Learn;
